<template>
  <a-drawer :title="id ? '编辑商品' : '创建商品'" width="500" :visible="visible" :closable="false"
    :footer-style="{ textAlign: 'right' }" @close="handleCancel">
    <!-- 表单数据 -->
    <a-form name="form" ref="RefForm" :model="formState" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <!-- 金额 -->
      <a-form-item label="金额" name="amount" :rules="[{ required: true, validator: validatorPrice }]">
        <a-input v-model:value="formState.amount" placeholder="请输入" />
      </a-form-item>
      <!-- 谷歌ID -->
      <a-form-item label="谷歌ID" name="google_id" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="formState.google_id" placeholder="请输入" />
      </a-form-item>
      <!-- 苹果ID -->
      <a-form-item label="苹果ID" name="apple_id" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="formState.apple_id" placeholder="请输入" />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleOk">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive } from 'vue'
import Loading from '@/components/Loading'
import { message } from 'ant-design-vue'
import { goodsAdd } from '@/api/admin'
import Pub from '@/utils/public'


// 注册父组件的事件
const emit = defineEmits('success')
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// id
let id = ref(undefined)
// 表单数据
let formState = reactive({
  // 金额
  amount: undefined,
  // 谷歌ID
  google_id: undefined,
  // 苹果ID
  apple_id: undefined,
})
// 加载
let isLoading = ref(false)

// 展示弹窗
function showDrawer(data) {
  visible.value = true
  // 金额
  formState.amount = undefined
  // 谷歌ID
  formState.google_id = undefined
  // 苹果ID
  formState.apple_id = undefined
  // 记录
  if (!!data) {
    id.value = data.id
    formState.amount = data.money
    formState.google_id = data.google_id
    formState.apple_id = data.apple_id
  }
}

// 关闭弹窗
function handleCancel() {
  // 重置表单
  RefForm.value.resetFields()
  visible.value = false
  // 重置
  id.value = undefined
  formState.google_id = undefined
  formState.apple_id = undefined
}

// 提交
function handleOk() {
  // 手动触发表单验证
  RefForm.value.validate()
    .then(() => {
      isLoading.value = true
      goodsAdd({
        id: id.value,
        google_id: formState.google_id,
        apple_id: formState.apple_id,
        money: formState.amount
      }).then(res => {
        // console.log(res);
        isLoading.value = false
        const { code, msg, data } = res
        if (code === 0) {
          message.success('操作成功')
          // 更新父组件
          emit('success')
          // 关闭弹窗
          handleCancel()
        } else {
          message.error(res.message || msg)
        }
      })
    })
}

// 效验 - 价格
function validatorPrice(rule, value) {
  if (!value) {
    return Promise.reject('请输入')
  } else if (!Pub.REG_IS_INTEGER_OR_FLOAT(value)) {
    return Promise.reject('必须为正数，且最多保留两位小数')
  }
  return Promise.resolve()
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped></style>